import React from 'react';
import { createRoot } from 'react-dom/client';
import CopyTranscriptDialog from './CopyTranscriptDialog';
import Logger from '../../../../services/Logger';

export default function showCopyTranscriptDialog({ transcript, isSettingsMode }) {
  const parentEl = document.querySelector('.wrapperDialog');

  const root = createRoot(parentEl);
  const handleCloseDialog = () => {
    Logger.log('User', 'TranscriptCopyingSettingsModalClosed');
    if (parentEl) root.unmount();
  };

  root.render(
    <CopyTranscriptDialog
      transcript={transcript}
      onClose={handleCloseDialog}
      isSettingsMode={isSettingsMode}
    />,
  );
}
